import { MonthView } from '@devexpress/dx-react-scheduler-material-ui';

export const CustomMonthLayout = (props: MonthView.LayoutProps) => {
  return <MonthView.Layout {...props}></MonthView.Layout>;
};
